import domainStores from './domain';
import uiStores from './ui';

export default {
    ...domainStores,
    ...uiStores
};

export * from './domain';
export * from './ui';